window.dataLayer = window.dataLayer || [];

const generateEventId = () => {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};

const sendGTMEventData = (ev, options) => {
  try {
    dataLayer.push({
      event: ev,
      event_id: generateEventId(),
      ...options
    });
  } catch (error) {
    console.error('Failed to send GTM event: ', error);
  }
};

function throttle(func, interval) {
  let timeout;
  return function() {
    const _this = this;
    const args = arguments;
    const later = function() {
      timeout = false;
    };
    if (!timeout) {
      func.apply(_this, args);
      timeout = true;
      setTimeout(later, interval || 100);
    }
  };
};

function getSectionFromClass(target) {
  let id = '';
  let section = null;
  let module = null;
  let name = '';
  if (target.classList.contains('template--product')) {
    section = target.querySelector('main section');
    module = section.querySelector('[data-module-name]');
    name = module ? module.getAttribute('data-module-name') || '' : '';
    
    if (section) {
      id = section.id
    }

    return {
      item_list_id: id,
      item_list_name: name
    }
  }
  
  section = target.closest('section') || target.closest('header')
  if (section) {
    id = section.id
  }

  module = target.closest('[data-module-name]');
  name = module ? module.getAttribute('data-module-name') || '' : '';

  return {
    item_list_id: id,
    item_list_name: name
  }
}

async function getCoupons(itemId) {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
  
    const itemWithCoupon = cart.items.find(({product_id, variant_id}) => 
      product_id.toString() === itemId || variant_id === itemId
    );

    if (!itemWithCoupon) return '';

    const coupons = itemWithCoupon.discounts.map(({title}) => title).join(',');
    
    return coupons
  }
  catch (error) {
    console.error('Error fetching cart data:', error);
    return '';
  }
}

// SCROLL
class Scroll {
  maxAmountOfMilestones = 5 // 0, 25, 50, 75, 100
  trackedMilestones = new Set();
  options = {
    increment: null,
    milestone: null
  };
  moveEv = window.matchMedia("(min-width: 1200px)").matches ? 'scroll' : 'touchmove';
  constructor() {
    if (typeof window !== 'undefined') {
      window.addEventListener(this.moveEv, this.scrollHandler, {passive: true});
    }
  }

  scrollHandler = throttle(() => {
    this.handleScroll();
  });

  handleScroll() {
    const scrollPercent = this.getScrollPercentage();
    
    const milestone = this.getScrollMilestone(scrollPercent);
    
    if (milestone === null) {
      return;
    }
    if (this.trackedMilestones.has(milestone)) {
      return;
    }

    if (Array.from(this.trackedMilestones).some((m) => m > milestone)) {
      return;
    }
    
    this.trackedMilestones.add(milestone);
    const increment = this.getScrollIncrement(milestone);

    this.options = { milestone, increment }

    sendGTMEventData(this.moveEv, {
      scroll_percent: milestone,
      scroll_increment: increment
    })

    if (this.trackedMilestones.size >= 5) {
      window.removeEventListener(this.moveEv, this.scrollHandler)
    }
  }

  getScrollPercentage() {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return 0;
    }

    // check for mobile devices
    const scrollTop = Math.max(
      window.pageYOffset,
      document.documentElement.scrollTop,
      document.body.scrollTop
    );
    const scrollHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );
    const clientHeight = Math.min(
      document.documentElement.clientHeight,
      document.body.clientHeight
    );
    const documentHeight = scrollHeight - clientHeight;

    if (documentHeight === 0) {
      return 0;
    }

    return Math.round((scrollTop / documentHeight) * 100);
  }

  getScrollMilestone(scrollPercent) {
    if (scrollPercent >= 0 && !this.trackedMilestones.has(0)) {
      return 0;
    }
    if (scrollPercent >= 25 && !this.trackedMilestones.has(25)) {
      return 25;
    }
    if (scrollPercent >= 50 && !this.trackedMilestones.has(50)) {
      return 50;
    }
    if (scrollPercent >= 75 && !this.trackedMilestones.has(75)) {
      return 75;
    }
    if (scrollPercent >= 100 && !this.trackedMilestones.has(100)) {
      return 100;
    }
    return null;
  }

  getScrollIncrement(milestone) {
    switch (milestone) {
      case 0:
        return '0%';
      case 25:
        return '25%';
      case 50:
        return '50%';
      case 75:
        return '75%';
      case 100:
        return '100%';
      default:
        return '0%';
    }
  }
}

const scroll = new Scroll()

// FILTER 
class Filter {
  drawer = '.js-drawer';
  applyEv = 'filter_apply';
  input = 'js-filter-ga';
  clear = 'js-filter-clear-all'

  constructor(selector) {
    window.addEventListener('DOMContentLoaded', () => {
      this.el = document.querySelector(selector);
      if (!this.el) return;
      this.apply();
      this.attachListeners();
      this.removeFilter();
      this.removeQuickFilter();
    });
  }

  apply() {
    this.el.addEventListener('click', () => {
      const data = this.getAllOptions(this.el);
      if (!data) return;
      sendGTMEventData(this.applyEv, data);
    });
  }

  removeFilter() {
    const btn = document.querySelector('.js-filter-remove');
    
    btn.addEventListener('click', (e) => {
      const data = this.getAllOptions(btn);
      if (!data) return;

      sendGTMEventData('filter_remove', data);
    });
  }

  removeQuickFilter() {
    document.addEventListener('click', ({ target }) => {
      if (!target.classList.contains(this.clear)) return;
      const links = document.querySelectorAll('.active-facets__button');
      
      const labels = Array.from(links).map(link => {
        
        const rangeLabel = link.querySelector('.active-facets__button--price-range')
        const label = rangeLabel ?
          rangeLabel.textContent.trim() :
          link.parentElement.parentElement.querySelector('.js-facet-label')?.textContent.trim();
        
         return label
      })
      labels.pop()
    });
  }

  attachListeners() {
    const inputEv = debounce((e) => {
      this.handleInput(e);
    }, 250);
    document.addEventListener('input', inputEv)
  }

  getFilterCategoryAndName(input) {
    const details = input.closest('details');
    let category = details?.querySelector('summary')?.textContent.trim() || '';
    let name = this.getInputName(input, details);

    const priceRange = input.closest('price-range');
    if (priceRange) {
      const label = priceRange.querySelector(`label[for="${input.id}"]`)?.textContent.trim();
      if (label) name = label;
    }

    return { category, name };
  }

  handleInput(e) {
    const target = e.target;
    if (!target.classList.contains(this.input)) return;
    const data = this.getFilterCategoryAndName(target);
    let eventName = ''
    if (target.type === 'checkbox') {
      eventName = target.checked ? 'filter_add' : 'filter_remove'
    } else {
      eventName = target.value !== '' ? 'filter_add' : 'filter_remove'
    }
    if (!data) return;
    sendGTMEventData(eventName, data);
  }

  handleTextField(parent, target) {
    return this.getFilterCategoryAndName(target);
  }

  getAllOptions(el) {
    const wrapper = el.closest(this.drawer);
    if (!wrapper) return null;

    const inputs = Array.from(wrapper.querySelectorAll('details input'));
    
    const items = inputs
      .filter(el => this.hasValue(el))
      .map(el => this.getFilterCategoryAndName(el));
    
    if (!items.length) return null;

    return {
      filter_category: [...new Set(items.map(i => i.category))].join(', '),
      filter_name: items.map(i => i.name).join(', ')
    };
  }

  hasValue(el) {
    if (el.type === 'checkbox' || el.type === 'radio') return el.checked;
    return el.value.trim() !== '';
  }

  getInputName(el, details) {
    if (el.type === 'checkbox' || el.type === 'radio') {
      const label = details?.querySelector(`label[for="${el.id}"]`);
      return label ? label.textContent.trim() : el.value;
    }
    return el.value.trim();
  }
}
const filter = new Filter('.js-ga-filter')

// PROMOTION
class Promotion {
  constructor() {}

  getElements() {
    return document.querySelectorAll('.js-promo-element');
  }

  async getProducts(target) {
    const templates = target.closest('.js-collection-grid').querySelectorAll('template');
    if (!templates.length) return [];

    const productPromises = Array.from(templates).map((template, index) => {
      return this.setProduct(template, index);
    });

    const products = await Promise.all(productPromises);
    return products.filter(p => p !== null);
  }

  getProduct(target) {
    const template = target.querySelector('template');
    if (!template) return;
 
    return this.setProduct(template);
  }

  async setProduct(template, index=0) {
    try {
      const couponData = await getCoupons(template.content.querySelector('id')?.textContent);

      return {
        id: template.content.querySelector('id')?.textContent,
        item_name: template.content.querySelector('title')?.textContent,
        item_brand: template.content.querySelector('itemBrand')?.textContent,
        item_category: template.content.querySelector('category')?.textContent,
        price: template.content.querySelector('price')?.textContent,
        quantity: template.content.querySelector('quantity')?.textContent,
        variants: template.content.querySelector('variants')?.textContent,
        location: template.content.querySelector('location')?.textContent || '',
        item_list_id: template.content.querySelector('itemListId')?.textContent,
        item_list_name: template.content.querySelector('itemListName')?.textContent,
        index: index,
        coupon: couponData,
        discount: template.content.querySelector('discount')?.textContent,
      };
    } catch (error) {
      console.error('Error setting product data:', error);
      return null;        
    }
  }
}
// View Promotion
class ViewPromotion extends Promotion {
  constructor() {
    super()
    window.addEventListener('DOMContentLoaded', () => {
      this.observeSection();
    })
  }

  async observeSection() {
    const sections = this.getElements()

    if (!sections.length) return
    const options = {
      threshold: 0.5
    }
    const intersectionObserver = new IntersectionObserver(async (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        
        if (entry.target.classList.contains('js-card-text')) {
          const products = await this.getProducts(entry.target);
          sendGTMEventData("view_promotion", {
            ecommerce: {
              items: products,
            }
          });
          continue;
        }
        
        const product = await this.getProduct(entry.target);
        sendGTMEventData("view_promotion", {
          ecommerce: {
            items: [product],
          }
        });
      }
    }, options);
    
    sections.forEach(section => intersectionObserver.observe(section));
  }
}

class ClickedPromotion extends Promotion {
  links = []
  constructor() {
    super()
     window.addEventListener('DOMContentLoaded', () => {
      this.selectPromotion();
    })
  }

  getClickableElements() {
    const sections = this.getElements();
    if (!sections.length) return
    
    sections.forEach(section => this.links.push(section.querySelector('button, a')))
  }

  async selectPromotion() {
    this.getClickableElements();
    
    if (!this.links.length) return
    this.links.forEach(link => {
      link.addEventListener('click', async () => {
        if (link.parentElement.classList.contains('js-interruption-link')) {
          const products = await this.getProducts(link);
          sendGTMEventData("select_promotion", {
            ecommerce: {
              items: products,
            }
          })
          return
        }
        const parent = link.closest('.js-promo-element')
        const product = await this.getProduct(parent);
         sendGTMEventData("select_promotion", {
            ecommerce: {
              items: [product],
            }
          })
        })
    })
  }
}

const viewPromotion = new ViewPromotion()
const clickedPromotion = new ClickedPromotion()

// VIEW ITEM LIST
class ViewList {
  constructor() {
    window.addEventListener('DOMContentLoaded', () => {
      this.observeList()
    })
  }

  getElements() {
    return document.querySelectorAll('.js-view-list');
  }

  async getItems(target) {
    const templates = target.querySelectorAll('template');
    if (!templates.length) return [];

    const itemPromises = Array.from(templates).map(async (template, index) => {
      try {
        const productId = template.content.querySelector('id')?.textContent;
        const couponData = await getCoupons(productId);
        
        return {
          item_id: productId,
          item_name: template.content.querySelector('title')?.textContent,
          affiliation: template.content.querySelector('itemBrand')?.textContent,
          item_category: template.content.querySelector('category')?.textContent,
          price: parseFloat(template.content.querySelector('price')?.textContent) || 0,
          quantity: parseInt(template.content.querySelector('quantity')?.textContent) || 1,
          item_variant: template.content.querySelector('variants')?.textContent,
          item_list_id: template.content.querySelector('itemListId')?.textContent,
          item_list_name: template.content.querySelector('itemListName')?.textContent,
          coupon: couponData,
          discount: template.content.querySelector('discount')?.textContent,
          index: index
        };
      } catch (error) {
        console.error('Error processing item:', error);
        return null;
      }
    });

    const items = await Promise.all(itemPromises);
    return items.filter(item => item !== null);
  }

  observeList() {
    const sections = this.getElements()
    if (!sections.length) return
    
    const intersectionObserver = new IntersectionObserver(async (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        
        const sectionData = getSectionFromClass(entry.target);
        const items = await this.getItems(entry.target);
        const currency = entry.target.dataset.currency || 'USD';
        
        const data = {
          ecommerce: {
            currency,
            ...sectionData,
            items
          }
        };
        
        sendGTMEventData("view_item_list", data);
      }
    });
    
    sections.forEach(section => intersectionObserver.observe(section));
  }
}

const viewList = new ViewList()

class ProductItem {
  constructor(event) {
    this.event = event
    window.addEventListener('DOMContentLoaded', () => {
      this.handleClick()
    })
  }

  async setData(target, index=0) {
    const template = target.closest('.swiper-slide')?.querySelector('template') || target.previousElementSibling;
    if (!template) return;

    const couponData = await getCoupons(template.content.querySelector('id')?.textContent);

    return {
      id: template.content.querySelector('id')?.textContent,
      item_name: template.content.querySelector('title')?.textContent,
      item_brand: template.content.querySelector('itemBrand')?.textContent,
      item_category: template.content.querySelector('category')?.textContent,
      price: template.content.querySelector('price')?.textContent,
      quantity: template.content.querySelector('quantity')?.textContent,
      variants: template.content.querySelector('variants')?.textContent,
      coupons: couponData,
      discount: template.content.querySelector('discount')?.textContent,
      index: index
    };
  }
  
  handleClick() {
    const productCards = this.getItems();
    if (!productCards.length) return
    productCards.forEach((card, index) => {
      card.addEventListener('click', async () => {
        const sectionData = getSectionFromClass(card)
        const item = await this.setData(card, index);
        const data = {
          ecommerce: {
            ...sectionData,
            items: [item]
          }
        }
        sendGTMEventData(this.event, data)
      })
    })
  }
}

class SelectItem extends ProductItem {
  constructor() {
    super('select_item')
  }

  getItems() {
    return document.querySelectorAll('product-card')
  }
}

class CardClicks {
  constructor() {
    window.addEventListener('DOMContentLoaded', () => {
      this.handleClick()
    })
  }

  getItems() {
    return document.querySelectorAll('product-card a')
  }

  handleClick() {
    const productCards = this.getItems();
    if (!productCards.length) return
    productCards.forEach(card => {
      card.addEventListener('click', () => {
        const title = card.dataset.title || ''
        const link = card.getAttribute('href') || ''
        const { item_list_name } = getSectionFromClass(card)
        const data = {
          ecommerce: {
           module_name: item_list_name,
           click_text: title,
           click_url: link
          }
        }
        sendGTMEventData('card_clicks', data)
      })
    })
  }
}

const selectItem = new SelectItem()
const cardClicks = new CardClicks()

// Tabs
class Tabs {
  constructor() {
    window.addEventListener('DOMContentLoaded', () => {
      this.handleTabs()
    })
  }
  handleTabs() {
    const tabs = document.querySelectorAll('.js-nav a:not(.product-card__link)');
    if (!tabs.length) return;
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const tabName = tab.textContent.trim();
        const { item_list_name } = getSectionFromClass(tab);
        const data = {
          click_text: tabName,
          module_name: item_list_name
        };
        sendGTMEventData('tab_clicks', data);
      });
    });
  }
}

const tabs = new Tabs();
